export default "__VITE_ASSET__BMls_vyy__"